<template>
    <draggable v-model="tags" @end="saveSorting">
        <div v-for="tag in tags" 
            :key="tag.id"
            class="px-2 py-3 text-left flex items-center justify-between">
            <i class="fa fa-bars text-grey flex-none"></i>
            <p class="mx-2 flex-1">
                <span v-if="! isAssignedtoRole(categoryId, tag.id)" class="text-red font-semibold">*</span>{{tag.name}} <br>
                <span class="uppercase text-xs text-grey font-medium">({{tag.abbv}})</span>
            </p>
        </div>
    </draggable>
</template>

<script>
import draggable from "vuedraggable";
import { mapGetters } from "vuex";

export default {
  components: {
    draggable
  },

  props: ["value", "category-id"],

  data() {
    return {
      tags: _.cloneDeep(this.value)
    };
  },

  methods: {
    isAssignedtoRole(cat_id, tag_id) {
      let categories = _.find(this.cat_tags, ["id", cat_id]);
      if (!_.isEmpty(categories)) {
        let tags = _.find(categories.tags, ["id", tag_id]);
        if (_.isEmpty(tags)) {
          return false;
        }
      }

      return true;
    },

    saveSorting() {
      _.each(this.tags, (tag, idx) => {
        let order = idx + 1;
        axios
          .patch(`api/vaults/${this.$route.params.vault_id}/categories/${this.categoryId}/tags/${tag.id}`, {
            name: tag.name,
            abbv: tag.abbv,
            order: order
          })
          .then(({ data }) => {
            if (idx == _.findLastIndex(this.tags)) {
              this.$ebus.$emit("get-categorized-tags");
              this.$ebus.$emit("tags-updated");
            }
          });
      });
    }
  },

  computed: {
    ...mapGetters({
      cat_tags: "getCategorizedTags"
    })
  },

  watch: {
    value: function(newValue, oldValue) {
      if (newValue) {
        this.tags = _.cloneDeep(newValue);
      }
    }
  }
};
</script>

<style>
</style>
